import type { ProductType } from '@dtp/membership-service-types';
import type { CompareMembershipBlockType, MembershipsType } from '@appTypes/CompareMembershipBlockType';
import { formattedPrice } from '@lib/formattedPrice';
import type { MembershipBoxProps } from './MembershipBox/MembershipBox.types';

export const IFK_CAMPAIGN_CODE = 'IFK';

type MembershipProducts = Record<ProductType['productNumber'], ProductType> | null | undefined;
type MembershipOption = Omit<MembershipBoxProps, 'selected' | 'onSelect'>;

export interface MembershipBundleProps {
  membershipProductData?: CompareMembershipBlockType;
}

export const membershipTitles: Record<string, string> = {
  '1111': 'Ja, jeg ønsker fullt NAF-medlemskap med veihjelp og alle medlemsfordeler',
  '1121': 'Jeg vil heller ha et redusert NAF-medlemskap uten blant annet veihjelp',
};

export const createMembershipOption = (
  membership: MembershipsType,
  products: MembershipProducts,
): MembershipOption => ({
  id: membership.productId || '',
  title: membershipTitles[membership.productId || ''] || '',
  hasBorder: true,
  showTag: membership.tag || false,
  benefitAccordions:
    membership.benefitAccordions
      ?.filter((accordion) => accordion.title && accordion.content)
      ?.map((accordion) => ({
        title: accordion.title!,
        content: accordion.content!,
        variant: accordion.variant,
      })) ?? [],
  price:
    membership.productId && products?.[membership.productId]?.productAppPrice?.['1']?.itemTotalPrice !== undefined
      ? formattedPrice(products[membership.productId].productAppPrice['1'].itemTotalPrice)
      : undefined,
});
